import { Resource } from "../type/Resource";
import { atomFamily } from "recoil";

export const isUpdatingPermissionByResourceAtomFamily = atomFamily<boolean, Resource>({
    key: "isUpdatingPermissionByResourceAtomFamily",
    default: false
});